import { NextRequest, NextResponse } from 'next/server';
import bcrypt from 'bcryptjs';

// In a real application, store credentials securely in a database
const VALID_USERS = [
  {
    username: 'admin',
    // Password: 'admin123' (hashed)
    passwordHash: '$2b$10$PrDvm/ckxMHmvpSAo11pruYKcjb1plPGa.FdZJDZycW7BDGTTi1uu'
  }
];

export async function POST(request: NextRequest) {
  try {
    const { username, password } = await request.json();

    if (!username || !password) {
      return NextResponse.json(
        { error: 'Username and password are required' },
        { status: 400 }
      );
    }

    const user = VALID_USERS.find(u => u.username === username);

    if (!user) {
      return NextResponse.json(
        { error: 'Invalid credentials' },
        { status: 401 }
      );
    }

    // Verify password
    const isValid = await bcrypt.compare(password, user.passwordHash);

    if (!isValid) {
      return NextResponse.json(
        { error: 'Invalid credentials' },
        { status: 401 }
      );
    }

    // Create response with authentication cookie
    const response = NextResponse.json(
      { success: true, message: 'Logged in successfully' },
      { status: 200 }
    );

    // Set HTTP-only cookie for security
    response.cookies.set('auth-token', 'authenticated', {
      httpOnly: true,
      secure: process.env.NODE_ENV === 'production',
      sameSite: 'strict',
      maxAge: 60 * 60 * 24, // 24 hours
      path: '/',
    });

    return response;
  } catch (error) {
    console.error('Authentication error:', error);
    return NextResponse.json(
      { error: 'Authentication failed' },
      { status: 500 }
    );
  }
}

export async function DELETE() {
  const response = NextResponse.json(
    { success: true, message: 'Logged out successfully' },
    { status: 200 }
  );

  // Clear the authentication cookie
  response.cookies.delete('auth-token');

  return response;
}
